/**
 * Health-Score: Persönliche Belastbarkeit und Resilienz.
 *
 * Heuristik (Konzept §4.2 Dimension 5) — diese Dimension ist heikel,
 * darf nicht zur Diskriminierung führen. Daher:
 *   - Keine direkten Abzüge für „chronische Erkrankung" allein.
 *   - Negative Wirkung nur, wenn Erkrankung die Tätigkeit nachweislich
 *     beeinträchtigt UND keine Coping-Strategie dokumentiert ist.
 *
 *   - Basis 30
 *   - Selbsteingeschätzte Resilienz (1-10):
 *       * ≥ 8: +25
 *       * 6-7: +15
 *       * 4-5: +5
 *       * 1-3: 0
 *   - Arbeitsstunden/Woche im Plausibilitätsbereich (20–55h): +10
 *     (außerhalb dieses Bereichs: 0 — Über- oder Unterauslastung)
 *   - Coping-Strategien dokumentiert (≥ 30 Zeichen): +10
 *   - Krisen-Bewältigungsnotizen vorhanden (≥ 30 Zeichen): +10
 *   - Wenn `conditionsAffectWork` und KEINE Coping-Strategie: -10
 *
 * Cap auf [0,100].
 */
import type { ScoreValue } from '../schema/brands.js';
import type { HealthData } from '../schema/dimensionData.js';
import { clampScore } from './internal/clamp.js';

export function computeHealthScore(data: HealthData): ScoreValue {
  let score = 30;

  const r = data.selfReportedResilienceScore ?? 0;
  if (r >= 8) score += 25;
  else if (r >= 6) score += 15;
  else if (r >= 4) score += 5;

  const hours = (data.hoursWorkedPerWeek as number | undefined) ?? 0;
  if (hours >= 20 && hours <= 55) score += 10;

  const copingDocumented = (data.copingStrategiesDescribed ?? '').trim().length >= 30;
  if (copingDocumented) score += 10;
  if ((data.pastCrisisHandlingNotes ?? '').trim().length >= 30) score += 10;

  if (data.conditionsAffectWork && !copingDocumented) {
    score -= 10;
  }

  return clampScore(score);
}
